import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "p-signup l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-signup__ttl c-ttl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-signup__ttl__logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "SHUEISHA ID"
    })
  ]),
  /*#__PURE__*/_createTextVNode("新規会員登録")
], -1)
const _hoisted_3 = { class: "p-messages" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "c-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "c-message__txt c-message__txt--primary" }, [
    /*#__PURE__*/_createElementVNode("i"),
    /*#__PURE__*/_createElementVNode("span", null, "英字大文字、英字小文字、数字いずれも含む8文字以上のパスワードを設定してください。")
  ])
], -1)
const _hoisted_5 = { class: "c-message" }
const _hoisted_6 = { class: "c-message__txt c-message__txt--primary" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("メールアドレスが登録できない場合は")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "こちら", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("をご確認ください。")
const _hoisted_11 = { class: "p-signin__field-container" }
const _hoisted_12 = { class: "p-errors" }
const _hoisted_13 = { class: "c-error" }
const _hoisted_14 = { class: "p-fields" }
const _hoisted_15 = { class: "c-field" }
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = { class: "c-field__input" }
const _hoisted_18 = { class: "c-field" }
const _hoisted_19 = { class: "c-field__body" }
const _hoisted_20 = { class: "c-field__input" }
const _hoisted_21 = { class: "c-field" }
const _hoisted_22 = { class: "c-field__body" }
const _hoisted_23 = { class: "c-field__input" }
const _hoisted_24 = { class: "c-field" }
const _hoisted_25 = { class: "c-field__body" }
const _hoisted_26 = { class: "c-field__input" }
const _hoisted_27 = { class: "c-field has-submit has-mt" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "登録する", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "p-signin__txt" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("すでにアカウントをお持ちの方は")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, [
            _hoisted_8,
            _createVNode(_component_router_link, {
              class: "c-link c-link--primary",
              to: { name: 'Help', hash: '#help_03' }
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _hoisted_10
          ])
        ])
      ])
    ]),
    _createVNode(_component_Form, {
      onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.register, this))),
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(({ errors, meta }) => [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.errorMsgRef), 1)
          ], 512), [
            [_vShow, _ctx.errorMsgRef]
          ]),
          _createElementVNode("fieldset", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "email",
                    modelValue: _ctx.cognitoInfo.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cognitoInfo.email) = $event)),
                    placeholder: "メールアドレス",
                    autocomplete: "email",
                    required: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.email), 513), [
              [_vShow, errors.email]
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "emailRetype",
                    value: "",
                    placeholder: "メールアドレス確認",
                    autocomplete: "email",
                    required: ""
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.emailRetype), 513), [
              [_vShow, errors.emailRetype]
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Field, {
                    type: _ctx.passwordToggle.fieldType,
                    name: "password",
                    modelValue: _ctx.cognitoInfo.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cognitoInfo.password) = $event)),
                    maxlength: _ctx.PASSWORD_MAX_LENGTH,
                    placeholder: "パスワード",
                    autocomplete: "new-password",
                    required: ""
                  }, null, 8, ["type", "modelValue", "maxlength"]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordToggle.isOn }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordToggle)))
                  }, null, 2)
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.password), 513), [
              [_vShow, errors.password]
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Field, {
                    type: _ctx.passwordRetypeToggle.fieldType,
                    name: "passwordRetype",
                    value: "",
                    maxlength: _ctx.PASSWORD_MAX_LENGTH,
                    placeholder: "パスワード確認",
                    autocomplete: "new-password",
                    required: ""
                  }, null, 8, ["type", "maxlength"]),
                  _createElementVNode("i", {
                    class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordRetypeToggle.isOn }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordRetypeToggle)))
                  }, null, 2)
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.passwordRetype), 513), [
              [_vShow, errors.passwordRetype]
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "submit",
                class: "c-btn is-submit",
                disabled: !meta.valid || _ctx.isDeterringRef
              }, _hoisted_30, 8, _hoisted_28)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createElementVNode("p", _hoisted_31, [
      _hoisted_32,
      _createVNode(_component_router_link, {
        class: "c-link c-link--primary",
        to: { name: 'Login' }
      }, {
        default: _withCtx(() => [
          _hoisted_33
        ]),
        _: 1
      })
    ])
  ]))
}